import {Inject, Injectable} from 'ng-metadata/core';
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {JwtUtilService} from "../../jwtUtil.service";
import {StorageUtil} from "../../../infra/storageUtil.service";
import {getVid} from "../../../appConfig/appConfigForward";
import {UNION_CATALOG_FAVORITE_STORAGE_KEY, UserSessionManagerService} from "../../userSessionManager.service";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";


const _clone = require('lodash/clone');

@Injectable()
export class UnionCatalogLoginService {
    constructor(private userSessionManagerService : UserSessionManagerService,
                @Inject('$state') private $state : ng.ui.IStateService,
                @Inject('$window') private $window: ng.IWindowService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private jwtUtilService: JwtUtilService,
                private storageUtil: StorageUtil,
                private mappingTablesCache: MappingTablesCache){

    }
    public async goToInstitutionLogin(institutionDetails: any) {
        let instCode = institutionDetails.code;
        let toParams = _clone(this.$state.params);
        let institutionVid = toParams.vid.replace(/.*:/, instCode + ':')
        toParams.vid = institutionVid;
        let href = this.$state.href(STATE_NAMES.LOGIN, {vid: institutionVid, lang: toParams.lang, unionCatalogNZVid: getVid(),
            toState: this.$state.current.name, toParams: JSON.stringify(toParams)});
        let user = this.jwtUtilService.getDecodedToken().user;
        let favorites  = await this.userSessionManagerService.createOrGetUserArea(user);
        this.storageUtil.sessionStorage.setItem(UNION_CATALOG_FAVORITE_STORAGE_KEY, JSON.stringify(favorites));
        this.$window.location.assign(href); //we need to use location assign because changing a vid requires a bootstrap of the app

    }

    public isUnionCatalogLogin(){
        return this.userSessionManagerService.isUnionCatalogLogin();
    }

    public returnToUnionCatalogNZView() {
        let params = JSON.parse(this.$stateParams.toParams);
        params.vid = this.$stateParams.unionCatalogNZVid;
        let href = this.$state.href(this.$stateParams.toState, params);
        this.$window.location.assign(href);
    }

    public getMemberInstitutionList() {
        let consortiaMembersTable = this.mappingTablesCache.getTable('consortia member codes');
        return consortiaMembersTable.map((memberRow)=>{return {name:memberRow.source2, code: memberRow.target};});
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/unionCatalogLogin.service.ts